import FormattedMessage from 'I18n/components/FormattedMessage';
import { Map as ImmutableMap } from 'immutable';
import { Component } from 'react';
import { connect } from 'react-redux';
import ContentRoutes from 'ContentUtils/Routes';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import MABExperimentModalControls from './MABExperimentModalControls';
import MABVariationDeleteModal from 'page-editor-ui/components/MABVariationDeleteModal';
import { deleteMABExperiment, updateMABExperimentVariants
// @ts-ignore not yet typed
} from 'page-editor-ui/redux/actions/mabExperimentActions';
import { getMABExperimentIsStarted, getMABExperimentLoading, getMABExperimentVariants, getMABExperimentMasterVariant
// @ts-ignore not yet typed
} from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getSubcategory } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = key => `mab.testManager.${key}`;
const mapDispatchToProps = {
  deleteMABExperiment,
  updateMABExperimentVariants
};
const mapStateToProps = state => {
  return {
    variants: getMABExperimentVariants(state),
    masterVariant: getMABExperimentMasterVariant(state),
    loading: getMABExperimentLoading(state),
    mabExperimentIsStarted: getMABExperimentIsStarted(state),
    subcategory: getSubcategory(state),
    // @ts-ignore state not yet typed
    categoryId: getCategoryId(state)
  };
};
class MABTestManagerModal extends Component {
  constructor(props) {
    super(props);
    this.handleMabOptionsChange = mabOptions => this.setState({
      mabOptions
    });
    this.handleVariationDeleteModalClose = () => {
      this.setState({
        showMabVariationDeleteModal: false
      });
    };
    this.handleVariationDeleteModalConfirm = () => {
      this.handleVariationDeleteModalClose();
      this.saveChanges();
    };
    this.handleEndUnstartedTest = () => {
      const {
        masterVariant
      } = this.props;
      const {
        mabOptions
      } = this.state;
      const masterVariationName = mabOptions.get('masterVariationName') || masterVariant.get('name');
      this.props.deleteMABExperiment({
        updatedMasterVariation: ImmutableMap({
          id: masterVariant.get('id'),
          name: masterVariationName
        })
      });
    };
    this.handleSaveChangesClick = () => {
      const {
        mabOptions
      } = this.state;
      const deletedVariationsCount = mabOptions.get('deletedVariations').size;
      if (deletedVariationsCount > 0) {
        this.setState({
          showMabVariationDeleteModal: true
        });
        return;
      }
      this.saveChanges();
    };
    this.saveChanges = () => {
      const {
        mabOptions
      } = this.state;
      const deletedVariations = mabOptions.get('deletedVariations');
      const masterVariationName = mabOptions.get('masterVariationName');
      const newVariantNames = mabOptions.get('newVariantNames');
      let updatedVariations = mabOptions.get('updatedVariations');
      const {
        variants,
        masterVariant
      } = this.props;
      const afterChangesVariationCount = variants.size + newVariantNames.size - deletedVariations.size;
      const masterVariationNameChanged = masterVariationName !== masterVariant.get('name');
      const updatedMasterVariation = ImmutableMap({
        id: masterVariant.get('id'),
        name: masterVariationName
      });
      if (afterChangesVariationCount === 0) {
        return this.props.deleteMABExperiment({
          updatedMasterVariation
        });
      }
      if (masterVariationNameChanged) {
        updatedVariations = updatedVariations.unshift(updatedMasterVariation);
      }
      return this.props.updateMABExperimentVariants(newVariantNames, deletedVariations, updatedVariations);
    };
    this.state = {
      mabOptions: ImmutableMap(),
      showMabVariationDeleteModal: false
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const {
      mabOptions,
      showMabVariationDeleteModal
    } = this.state;
    const {
      loading,
      mabExperimentIsStarted,
      show
    } = this.props;
    return loading !== nextProps.loading || mabExperimentIsStarted !== nextProps.mabExperimentIsStarted || mabOptions.isEmpty() || !mabOptions.equals(nextState.mabOptions) || show !== nextProps.show || showMabVariationDeleteModal !== nextState.showMabVariationDeleteModal;
  }
  renderMABVariationDeleteModal() {
    const {
      variants
    } = this.props;
    const {
      mabOptions,
      showMabVariationDeleteModal
    } = this.state;
    if (!showMabVariationDeleteModal) {
      return null;
    }
    const newVariantNames = mabOptions.get('newVariantNames');
    const deletedVariations = mabOptions.get('deletedVariations');
    const initialVariationCount = variants.size;
    const newVariationCount = newVariantNames.size;
    const afterChangesVariationCount = initialVariationCount + newVariationCount - deletedVariations.size;
    return /*#__PURE__*/_jsx(MABVariationDeleteModal, {
      afterChangesVariationCount: afterChangesVariationCount,
      deletedVariations: deletedVariations,
      mabExperimentIsStarted: this.props.mabExperimentIsStarted,
      onClose: this.handleVariationDeleteModalClose,
      onDelete: this.handleVariationDeleteModalConfirm
    });
  }
  renderSaveOrEndTestButton() {
    const {
      mabExperimentIsStarted,
      masterVariant,
      subcategory,
      categoryId
    } = this.props;
    if (mabExperimentIsStarted) {
      return /*#__PURE__*/_jsx(Button, {
        use: "danger",
        href: `${ContentRoutes.details(masterVariant.get('id'), categoryId, subcategory, null, {
          tab: 'testResults'
        })}?mabEndTestModalOpen=true`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('endTestButton')
        })
      });
    }
    const {
      mabOptions
    } = this.state;
    const isValid = mabOptions.get('isValid');
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "danger",
        onClick: this.handleEndUnstartedTest,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('deleteUnstartedTestButton')
        })
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !isValid,
        use: "primary",
        onClick: this.handleSaveChangesClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('confirmButton')
        })
      })]
    });
  }
  render() {
    const {
      loading,
      masterVariant,
      onClose,
      show,
      variants,
      mabExperimentIsStarted
    } = this.props;
    if (!show) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Modal, {
      "data-test-id": "mab-modal",
      width: 650,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsxs(TFlex, {
          align: "baseline",
          direction: "row",
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('header')
            })
          }), /*#__PURE__*/_jsx(Badge, {
            marginInlineStart: "200",
            use: mabExperimentIsStarted ? 'green' : 'default',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey(mabExperimentIsStarted ? 'status.live' : 'status.notStarted')
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsxs(View, {
          paddingInline: "1300",
          as: "div",
          children: [/*#__PURE__*/_jsx(MABExperimentModalControls, {
            existingVariants: variants,
            isEditMode: true,
            masterContentName: masterVariant.get('name'),
            onOptionsChange: this.handleMabOptionsChange,
            mabExperimentIsStarted: mabExperimentIsStarted
          }), this.renderMABVariationDeleteModal(), loading && /*#__PURE__*/_jsx(LoadingOverlay, {})]
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsxs(View, {
          paddingInline: "1300",
          as: "div",
          children: [this.renderSaveOrEndTestButton(), /*#__PURE__*/_jsx(Button, {
            use: "secondary",
            onClick: onClose,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('cancel')
            })
          })]
        })
      })]
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MABTestManagerModal);